import { w as x } from "../withTheme-zx3wTAWo.es.js";
import c from "react";
import t from "prop-types";
import g from "classnames";
import k from "lodash";
import { n as R } from "../Normalize.module-BSsVv-vB.es.js";
import { N as B } from "../NoClickOutline-CllwvnB9.es.js";
import '../index8.css';const q = "BaseToggle-default-module__enabled_container___Q6Zq6", E = "BaseToggle-default-module__disabled_container___YRXW5", M = "BaseToggle-default-module__toggle___w6laH", N = "BaseToggle-default-module__right___KjKvb", I = "BaseToggle-default-module__left___xv-jZ", P = "BaseToggle-default-module__active___ewIEV", w = "BaseToggle-default-module__inactive___uMYo5", z = "BaseToggle-default-module__icon___kShcz", O = "BaseToggle-default-module__blue___Vpj9i", Z = "BaseToggle-default-module__gray___yFxoJ", j = "BaseToggle-default-module__green___xWljB", A = "BaseToggle-default-module__lavender___8ktcc", C = "BaseToggle-default-module__purple___AFxbZ", F = "BaseToggle-default-module__red___Pa9XJ", J = "BaseToggle-default-module__text___JhMOn", K = {
  enabled_container: q,
  disabled_container: E,
  toggle: M,
  right: N,
  left: I,
  active: P,
  inactive: w,
  icon: z,
  blue: O,
  gray: Z,
  green: j,
  lavender: A,
  purple: C,
  red: F,
  text: J
}, Y = "BaseToggle-compere-module__enabled_container___icJgf", L = "BaseToggle-compere-module__disabled_container___NAnz2", S = "BaseToggle-compere-module__toggle___TN9UY", X = "BaseToggle-compere-module__right___vC23t", G = "BaseToggle-compere-module__left___7MVeD", H = "BaseToggle-compere-module__active___n0ouZ", W = "BaseToggle-compere-module__inactive___-Ge2-", D = "BaseToggle-compere-module__icon___ApEkF", Q = "BaseToggle-compere-module__blue___hZ25G", U = "BaseToggle-compere-module__gray___mdXg1", V = "BaseToggle-compere-module__green___RLVzm", ee = "BaseToggle-compere-module__pink___uAuui", oe = "BaseToggle-compere-module__purple___q76Hd", te = "BaseToggle-compere-module__text___ep3YP", ne = {
  enabled_container: Y,
  disabled_container: L,
  toggle: S,
  right: X,
  left: G,
  active: H,
  inactive: W,
  icon: D,
  blue: Q,
  gray: U,
  green: V,
  pink: ee,
  purple: oe,
  text: te
}, v = {
  default: K,
  compere: ne
}, i = ({
  selectedValue: e,
  disabled: l,
  leftValue: n,
  rightValue: _,
  onToggle: s,
  children: d,
  color: u,
  theme: b,
  focus: h,
  reset: m,
  icon: p,
  leftTitle: y,
  rightTitle: $
}) => {
  const a = (r) => {
    e !== r && !l && (s(r), m());
  }, f = (r) => {
    e !== r && !l && h();
  }, T = (r) => {
    e !== r && !l && m();
  };
  _ === n && console.error(
    "Invalid prop supplied to BaseToggle. props.rightValue and props.leftValue cannot be the same."
  ), e !== n && e !== _ && console.error(
    `Invalid prop supplied to BaseToggle. selectedValue must match either props.rightValue: ${_} or props.leftValue ${n}`
  );
  const o = k.get(v, b, v.default);
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: g(R.normalize, {
        [o.enabled_container]: !l,
        [o.disabled_container]: l,
        [o.icon]: p,
        [o.text]: !p
      })
    },
    /* @__PURE__ */ c.createElement(
      B.Button,
      {
        disabled: l,
        className: g(
          o.toggle,
          o.left,
          o[u],
          {
            [o.active]: e === n,
            [o.inactive]: e !== n
          }
        ),
        onClick: () => a(n),
        onKeyPress: () => a(n),
        onMouseEnter: () => f(n),
        onMouseLeave: () => T(n),
        tabIndex: 0,
        "aria-checked": e === n,
        title: y
      },
      d[0]
    ),
    /* @__PURE__ */ c.createElement(
      B.Button,
      {
        disabled: l,
        className: g(
          o.toggle,
          o.right,
          o[u],
          {
            [o.active]: e === _,
            [o.inactive]: e !== _
          }
        ),
        onClick: () => a(_),
        onKeyPress: () => a(_),
        onMouseEnter: () => f(_),
        onMouseLeave: () => T(_),
        tabIndex: 0,
        "aria-checked": e === _,
        title: $
      },
      d[1]
    )
  );
};
i.propTypes = {
  selectedValue: t.string.isRequired,
  disabled: t.bool,
  leftValue: t.string.isRequired,
  rightValue: t.string.isRequired,
  onToggle: t.func.isRequired,
  children: t.arrayOf(
    (e, l, n, _, s) => e.length !== 2 ? new Error(
      `Invalid prop \`${s}\` supplied to \`${n}\`. Requires exactly 2 children, ${e.length} provided.`
    ) : null
  ).isRequired,
  color: t.oneOf([
    "red",
    "blue",
    "purple",
    "lavender",
    "gray",
    "green",
    "pink"
  ]),
  theme: t.oneOf(["default", "compere"]),
  focus: t.func,
  reset: t.func,
  icon: t.bool,
  leftTitle: t.string,
  rightTitle: t.string
};
i.defaultProps = {
  theme: "default",
  disabled: !1,
  focus: () => null,
  icon: !1,
  reset: () => null,
  color: null,
  leftTitle: null,
  rightTitle: null
};
const ie = x(i);
export {
  ie as default
};
